import type { GuideStep } from '../types';

export const MULTI_SHEET_STEPS: GuideStep[] = [
  {
    id: 'multisheet-1',
    page: 'index',
    section: 'multi-sheet',
    target: 'sheet-tabs',
    mobileTarget: null,
    minPlan: 'advanced',
    title: { sv: 'Flera blad', en: 'Multiple sheets' },
    body: {
      sv: 'Ett workflow kan ha flera blad (tabs). Var och en är en egen canvas — perfekt för att dela upp stora system i fasade delar.',
      en: 'A workflow can have multiple sheets (tabs). Each is its own canvas — perfect for splitting large systems into phased parts.',
    },
    placement: 'top',
    order: 1,
  },
  {
    id: 'multisheet-2',
    page: 'index',
    section: 'multi-sheet',
    target: 'sheet-add',
    mobileTarget: null,
    minPlan: 'advanced',
    title: { sv: 'Korskopplingar', en: 'Cross-sheet connectors' },
    body: {
      sv: 'Dra en koppling från ett block till ett annat blad — den visas som en pil-ut-ur-kanten med bladets namn. Bara angränsande blad kan kopplas ihop.',
      en: 'Drag a connector from a block to another sheet — it shows as an off-edge arrow with the sheet name. Only adjacent sheets can be linked.',
    },
    placement: 'top',
    order: 2,
  },
];
